app.service('basketRetrieveCart', function (modal, orderConfig) {
	var $self;
	var config;

	function open() {
		modal.open('retrieve-cart');
	}
	function retriveCart() {
		$.ajax({
			type: "POST",
			url: '/cart.ltr',
			data: {
				c: $("#cookieToRetrieve").val()
			},
			cache: false,
			success: function (html) {
				document.location.href = '/cart.bhtml';
			}, error: function () {
				modal.alert('Wystąpił błąd.');
			}
		});
	}
	function setElements() {
		$self = $('#retrieve-cart');
		config = orderConfig.getData();
	}
	function setEvents() {
		$('.js-retrieve-cart-confirm', $self).on('click', function () {
			retriveCart();
		});
	}
	function init() {
		setElements();
		setEvents();
		if (config.retrieveCartQuestion) {
			open();
		}
	}

	return {
		init: init
	};
});
